import {SaleModel} from "../../../blog/common/model/salemodel"

export class SaleList {
    _$wrapper = null;
    _$wrapperMobile = null;
    _scroll = null;
    _scrollMobile = null;
    pages = new ko.observableArray();
    total = 0;

    /**
     *
     * @param {object[]} pages
     * @param {function} itemsLoadedCallback Called for each rendered item, accepts DOM Element as parameter
     */
    constructor(pages, total, shopId, wrapper, wrapperMobile) {
        this._$wrapper = $(wrapper);
        this._$wrapperMobile = $(wrapperMobile);
        pages.forEach(item => {
            this.pages.push(new SaleModel(item));
        });
        this.total = total;

        this._scroll = this._$wrapper.zInfiniteScroll(
            {
                selector: '.sale-item',
                checkViewport: false,
                enabled: true,
                autoStart: false,
                maxAutoloadPages: 100,
                getCurrentCount: () => this.pages().length,
                totalCount: total,
                countPerPage: 20,
                loading: '#salesScrollLoader',
                fetch: (page, callback) => {
                    $.get(
                        '/shops/getSales',
                        {
                            page: page,
                            shop_id: shopId
                        },
                        (response) => {
                            callback(response.sales);
                        },
                        'json'
                    )
                },
                show: (items) => {
                    items.forEach(item => {
                        this.pages.push(new SaleModel(item));
                    });
                    return items.length;
                }
            }
        );

        this._scrollMobile = this._$wrapperMobile.zInfiniteScroll(
            {
                selector: '.mobile-sale-item',
                checkViewport: false,
                enabled: true,
                autoStart: false,
                maxAutoloadPages: 100,
                getCurrentCount: () => this.pages().length,
                totalCount: total,
                countPerPage: 20,
                loading: '#salesScrollLoaderMobile',
                fetch: (page, callback) => {
                    $.get(
                        '/shops/getSales',
                        {
                            page: page,
                            shop_id: shopId
                        },
                        (response) => {
                            callback(response.sales);
                        },
                        'json'
                    )
                },
                show: (items) => {
                    items.forEach(item => {
                        this.pages.push(new SaleModel(item));
                    });
                    return items.length;
                }
            }
        );
    }

    postInit() {
        this._scroll.on();
        this._scrollMobile.on();
    }

    afterRender(elements, data) {
        $(elements).find('.sale-name-inner').adaptiveFontSize({
            done: (el) => {
                $(el).parent().css('opacity', 1).addClass('centered');
            }
        });
    }

    refreshMobile() {
        const self = this;
        this._$wrapperMobile.find('.mobile-sale-item').each(function(){
            self.afterRender(this);
        });
    }
}


// WEBPACK FOOTER //
// ./modules/shops/page/model/salelist.js